import type { Role } from "src/hooks/useAuth";

export type MenuItemConfig = {
	key: string;
	path: string;
	icon: string;
	position: number;
	roles?: Role[];
};

export const menuConfig: MenuItemConfig[] = [
	{
		key: "rundown",
		path: "/rundown",
		icon: "calendar",
		position: 1,
	},
	{
		key: "rundowns",
		path: "/rundowns",
		icon: "queue",
		position: 2,
	},
	{
		key: "medialibrary",
		path: "/medialibrary",
		icon: "media",
		position: 3,
	},
	{
		key: "settings",
		path: "/settings",
		icon: "cog",
		position: 4,
		roles: ["superadmin", "admin"],
	},
];
